import { Performance } from '../services/performance.service';

// This file was adapted from the OneDrive codebase: https://onedrive.visualstudio.com/OneDriveWeb/_git/odsp-next?path=%2Fsrc%2Flocal%2FdataSources%2Fupload%2Fvroom%2FVroomUploader.ts&version=GBmaster&_a=contents

/**
* Utility which verifies whether an activity has enough bandwidth to succeed within
* a timeout based on current progress and total size.
*/
export class ActivityBandwidthVerifier {

    private readonly startTime: number;
    private readonly expirationTime: number;

    private progressPoints: number;

    constructor(
        timeout: number,
        private readonly totalBytes: number
    ) {
        this.startTime = Performance.now();
        this.expirationTime = this.startTime + timeout;
        this.progressPoints = 0;
    }

    /**
    * Determines whether the activity will have enough time to complete based on
    * current progress.
    */
    public doesActivityHaveRemainingCapacity(completedBytes: number): boolean {
        const rateRatio = this.getRateRatio(completedBytes);

        return typeof (rateRatio) !== 'undefined' ? rateRatio <= 1 : true;
    }

    /**
     * Determines whether the activity completed with time to spare.
     */
    public didActivityHaveExtraCapacity(): boolean {
        const currentTime = Performance.now();
        const elapsedDuration = currentTime - this.startTime;
        const remainingDuration = this.expirationTime - currentTime;

        return remainingDuration > elapsedDuration;
    }

    /**
     * Calculates the ratio of the required remaining rate over the current rate.
     */
    private getRateRatio(completedBytes: number): number {
        this.progressPoints++;

        const currentTime = Performance.now();

        const elapsedDuration = currentTime - this.startTime;
        const remainingDuration = this.expirationTime - currentTime;
        const remainingBytes = this.totalBytes - completedBytes;

        let rateRatio: number;

        if (this.progressPoints >= 4 && elapsedDuration >= 4 * 1000 && remainingDuration > 0 && elapsedDuration > 0) {
            rateRatio = (remainingBytes / remainingDuration) / (completedBytes / elapsedDuration);
        }

        return rateRatio;
    }
}
